<template>
    <form class="form" method="put">

      <HeaderApp />
      <div class="appCollectionAdminVueComponent appFontBlack">
          <h2>Administration des factures</h2>
            <input type="text" v-model="search" class="appSearchBar" placeholder="Numéro de facture" id= "numberInvoice">
            <button @click.prevent="searchInvoice()" type="submit" class="appButtonModel2"> rechercher</button>
            <br>
            <br>

        <div class="settingDivFont">
            <div class="appGroupOfDivNamesAndInput">
            <div class="appGroupOfDivNames">
                <p class="appLabelStyle1">Facture Id</p>
                <p class="appLabelStyle1">User Id</p>
                <p class="appLabelStyle1">Date facture</p>
                <p class="appLabelStyle1">Numéro</p>
                <p class="appLabelStyle1">Client</p>
                <p class="appLabelStyle1">lignes</p>
                <p class="appLabelStyle1">Réduction (%)</p>
                <p class="appLabelStyle1">Réduction (€)</p>
                <p class="appLabelStyle1">Espèces</p>
                <p class="appLabelStyle1">Cheques</p>
                <p class="appLabelStyle1">CB</p>
                <p class="appLabelStyle1">Virement</p>
                <p class="appLabelStyle1">Paypal</p>
                <p class="appLabelStyle1">Total</p>
                <p class="appLabelStyle1">Code facture</p>
                <p class="appLabelStyle1">Fiche technique</p>
                <p class="appLabelStyle1">Encaissé le</p>
                <p class="appLabelStyle1">Paiement par</p>
            </div>
          <div class="appGroupOfInput">
            <input v-model="invoice._id" type="string" name="invoiceId" class="appInputStyle1" disabled="disabled" id="idToUse">
            <input v-model="invoice.userId" type="string" name="userId" class="appInputStyle1" disabled="disabled">
            <input v-model="invoice.date" type="string" name="date" class="appInputStyle1">
            <input v-model="invoice.number" type="Number" name="number" class="appInputStyle1">
            <input v-model="invoice.client" type="string" name="client" class="appInputStyle1">
            <input v-model="invoice.lines" type="Array" name="lines" class="appInputStyle1" disabled="disabled">
            <input v-model="invoice.reduction" type="Number" name="reduction" class="appInputStyle1">
            <input v-model="invoice.amountreduction" type="Number" name="amountreduction" class="appInputStyle1">
            <input v-model="invoice.paiementEspeces" type="Number" name="paiementEspeces" class="appInputStyle1">
            <input v-model="invoice.paiementCheques" type="Number" name="paiementCheques" class="appInputStyle1">
            <input v-model="invoice.paiementCB" type="Number" name="paiementCB" class="appInputStyle1">
            <input v-model="invoice.paiementPaylib" type="Number" name="paiementPaylib" class="appInputStyle1">
            <input v-model="invoice.paiementPaypal" type="Number" name="paiementPaypal" class="appInputStyle1">
            <input v-model="invoice.totalprice" type="Number" name="totalprice" class="appInputStyle1">
            <input v-model="invoice.categoryOfInvoice" type="Number" name="categoryOfInvoice" class="appInputStyle1" disabled="disabled">
            <input v-model="invoice.technicalData" type="string" name="technicalData" class="appInputStyle1">
            <input v-model="invoice.dateBank" type="string" name="dateBank" class="appInputStyle1">
            <select v-model="invoice.typeofpaiement" type="string" name="typeofpaiement" class="appInputStyle1">
              <option valeur="Espèces">Espèces</option>
              <option valeur="Chèques">Chèques</option>
              <option valeur="CB">CB</option>
              <option valeur="Paylib">Virement</option>
              <option valeur="Paypal">Paypal</option>
            </select>
          </div>
        </div>
        <br>
          <button @click.prevent="modifyAdmin()" type="submit" class="appButtonModel2"> Modifier la facture</button>
        </div>
        <br>
        <div class="settingDivFont">
          <button @click.prevent="deleteInvoice()" type="submit" class="appButtonModel2"> Supprimer la facture</button>
        </div>
        <br>
      </div>

    </form>
  </template>

<script>
import HeaderApp from '../Application/HeaderApp.vue'
import axios from 'axios'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'AppCollectionAdmin',
  data () {
    return {
      invoice: ''
    }
  },
  methods: {
    searchInvoice () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      const numberInvoice = document.getElementById('numberInvoice')
      const numberInvoiceNumber = parseInt(numberInvoice.value)
      axios
        .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.invoice = response.data
          var extractionOfInvoice = this.invoice.filter(function (listing) {
            return listing.number === numberInvoiceNumber
          })
          const myInvoice = extractionOfInvoice[0]._id
          axios.get(('https://privilegia.fr/api/factures/' + myInvoice), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
            .then((response) => {
              this.invoice = response.data
            })
        })
    },
    modifyAdmin () {
      if (confirm('Valider mes modifications ?')) {
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const valeurId = document.getElementById('idToUse').value
        axios
          .put('https://privilegia.fr/api/factures/' + valeurId,
            {
              'userId': this.invoice.userId,
              'date': this.invoice.date,
              'number': this.invoice.number,
              'client': this.invoice.client,
              'lines': this.invoice.lines,
              'reduction': this.invoice.reduction,
              'amountreduction': this.invoice.amountreduction,
              'typeofpaiement': this.invoice.typeofpaiement,
              'paiementEspeces': this.invoice.paiementEspeces,
              'paiementCheques': this.invoice.paiementCheques,
              'paiementCB': this.invoice.paiementCB,
              'paiementPaylib': this.invoice.paiementPaylib,
              'paiementPaypal': this.invoice.paiementPaypal,
              'totalprice': this.invoice.totalprice,
              'categoryOfInvoice': this.invoice.categoryOfInvoice,
              'technicalData': this.invoice.technicalData,
              'dateBank': this.invoice.dateBank
            }, {headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' }})
          .then((response) => {
            window.alert('Données modifiées - facture N°' + this.invoice.number)
            this.$router.push('/App/Home')
          })
          .catch((error) => {
            console.log(error.response.data)
          })
      }
    },
    deleteInvoice () {
      if (window.confirm('Supprimer cette facture ?')) {
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const valeurId = document.getElementById('idToUse').value
        axios
          .delete('https://privilegia.fr/api/factures/' + valeurId,
            { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
          .then((response) => {
            window.alert('Facture supprimée')
            this.$router.push('/App/Home')
          })
          .catch((error) => {
            console.log(error.response.data)
          })
      } else {
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/application/AppCollectionAdmin.vue